import { css } from '@emotion/react';
import type { CSSInterpolation } from '@emotion/serialize';
import type { ReactNode } from 'react';

const styles = {
	root: css({
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
		marginTop: '1.25rem',
		marginBottom: '1.25rem',
	}),
	side: css({
		// Use flex so that buttons with no text content will not be misaligned.
		display: 'flex',
		alignItems: 'flex-end',
		'& > * + *': {
			marginLeft: '1.25rem',
		},
	}),
};

export interface ButtonRowProps {
	/** Buttons that go on the left side of the gap. */
	left?: ReactNode;
	leftStyle?: CSSInterpolation;
	/** Buttons that go on the right side of the gap. */
	right?: ReactNode;
	rightStyle?: CSSInterpolation;
	outerStyle?: CSSInterpolation;
}

/**
 * A container to layout buttons in a split row on the bottom of a form.
 */
export function ButtonRow(props: ButtonRowProps) {
	return (
		<div data-testid="button-row" css={[styles.root, props.outerStyle]}>
			<div css={[styles.side, props.leftStyle]}>{props.left}</div>

			<div css={[styles.side, props.rightStyle]}>{props.right}</div>
		</div>
	);
}
